import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function LocaleProvider({ children }) {
    const { i18n } = useTranslation();

    useEffect(() => {
        const lang = i18n.language?.startsWith('es') ? 'es' : 'en';
        document.documentElement.lang = lang;
    }, [i18n.language]);

    return children;
}
